(function informationBoxDirectiveDefinition() {
    'use strict';

    angular.module('informationBoxControl', [])
        .directive('informationBox', function () {
            return {
                restrict: 'E',
                templateUrl: '/app/directives/information-box/information-box.html',
                scope:
                   {
                       legend: '=ngModel'
                   },
                controller: [
                        '$scope', '$element', function ($scope, $element) {

                            $scope.informationText = $scope.legend.message;

                            switch ($scope.legend.type) {
                                case 'info':
                                    $scope.iconClass = 'glyphicon glyphicon-info-sign';
                                    $scope.dvBoxClass = 'info-box';
                                    break;
                                case 'success':
                                    $scope.iconClass = 'glyphicon glyphicon-ok-sign';
                                    $scope.dvBoxClass = 'success-box';
                                    break;
                                case 'error':
                                    $scope.iconClass = 'glyphicon glyphicon-remove-sign';
                                    $scope.dvBoxClass = 'error-box';
                                    break;
                                case 'notice':
                                    $scope.iconClass = 'glyphicon glyphicon-exclamation-sign';
                                    $scope.dvBoxClass = 'notice-box';
                                    break;
                                case 'download':
                                    $scope.iconClass = 'glyphicon glyphicon-download-alt';
                                    $scope.dvBoxClass = 'download-box';
                                    break;
                                default:
                                    $scope.iconClass = 'glyphicon glyphicon-exclamation-sign';
                                    $scope.dvBoxClass = 'notice-box';
                            }

                            jQuery(document).ready(function () {
                                $(".info .toggle-alert").click(function () {
                                    $(this).closest(".info").slideUp();
                                    return false;
                                });
                            });
                        }],
            };
        });
})();